import UnauthUsage from 'app/common/lib/UnauthUsage';
import { HybridTiers } from 'app/common/react/components/growth/unauth/open/hybrid/hybridConstants';
import { SignupTypes } from 'app/common/react/components/growth/unauth/signup/constants';

const SHOW_MODAL_AFTER_CLICKTHROUGH_COUNT = 2;

const getHybridClickthroughUpsell = (marketTier) => {
  const count = UnauthUsage.getUnauthClickthroughCount();
  switch (marketTier) {
    case HybridTiers.tier1:
      if (count === SHOW_MODAL_AFTER_CLICKTHROUGH_COUNT || count % 5 === 0) {
        return SignupTypes.login;
      }
      return null;
    case HybridTiers.tier2:
      if (count >= SHOW_MODAL_AFTER_CLICKTHROUGH_COUNT) {
        return SignupTypes.signupOrPersonalizedLogin;
      }
      return null;
    case HybridTiers.tier3:
      if (count >= SHOW_MODAL_AFTER_CLICKTHROUGH_COUNT) {
        return SignupTypes.signupOrPersonalizedLogin;
      }
      return null;
    default:
      return null;
  }
};

export default getHybridClickthroughUpsell;
